// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26fGI","content":"styles_content__2jEt1"};